<div class="flex flex-row pb-3 justify-between pr-2 relative items-center">
    <h2 mat-dialog-title class="dialog-heading">{{this.heading}}</h2>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 relative h-96 max-h-96 overflow-y-auto">
    <ng-container *ngIf="this.promoList?.length;else noDataFound">
        <div class="flex flex-col gap-4">
            <ng-container *ngFor="let item of this.promoList">
                <div [ngClass]="false ? 'border-orange-color' : 'border-slaty-color cursor-pointer'" matRipple
                    class="border w-full px-4 rounded-lg py-4 flex bg-slaty-color justify-between items-start">
                    <div class="flex-1">
                        <h4
                            class="lg:text-xl md:text-lg sm:text-base text-base text-blue-theme-color mb-2 font-bold leading-6">
                            {{item.topTitle | titlecase}}</h4>
                        <div class="flex flex-col gap-2">
                            <p
                                class="lg:text-xl md:text-lg sm:text-base text-base leading-6 text-blue-theme-color font-normal">
                                {{item.topDescription | titlecase}}</p>
                            <h4
                                class="lg:text-2xl md:text-xl sm:text-lg text-lg text-blue-theme-color mb-2 font-bold leading-6">
                                {{item.promoTitle}}</h4>
                        </div>
                    </div>
                    <!-- <mat-icon class="material-icons text-blue-theme-color font-bold">arrow_forward</mat-icon> -->
                    <button color="primary" (click)="this._matDialogRef.close(item)"
                        class="!bg-blue-theme-color min-w-44 md!px-3 sm:px-2 px-2 md!h-8 sm:h-6 !h-6 text-white-color !rounded-none ml-auto mr-0"
                        mat-flat-button>Apply
                    </button>
                </div>
            </ng-container>
        </div>

    </ng-container>
    <ng-template #noDataFound>
        <p class="absolute top-1/2 left-1/2 translate-x-[-50%]  translate-y-[-50%]">Promo unavailable.</p>
    </ng-template>
</mat-dialog-content>